


























































































import {
  computed, defineComponent, onMounted, reactive, ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import {
  createMaterial,
  updateMaterial,
  getItemGroups,
  getStockLocations,
  getMaterial,
  getSuppliers,
} from '@/api/index';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';
import useAuth from '@/use/useAuth';

const CommonFormWithMaterialEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    StickyFooterActionBar,
  },
  props: {
    edit: { default: false },
    useWithModal: { default: false },
  },
  setup(props, { emit, root }) {
    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }
    const { route, router } = useRouter();
    const confirmModal = ref(null);
    const getSuppliersResult = (data: any) => data.data.data;
    const getItemGroupsResult = (data: any) => data.data.data;
    const getStockLocationsResult = (data: any) => data.data.data;

    const form = reactive({
      id: -1,
      name: '',
      code: '',
      itemGroup: undefined,
      stockLocation: undefined,
      type: '',
      brand: '',
      unit: '',
      defaultPurchaseUnit: '',
      supplier: null,
      warnAmount: 0,
      suppliers: [],
      call: async () => {
        if (props.edit === true) {
          const result = await updateMaterial(form.id, materialInput.value);
        } else {
          const result = await createMaterial(materialInput.value);
        }
        if (props.useWithModal) {
          emit('done');
        } else {
          (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
          router.push({ name: 'StorePartList' });
        }
      },
      state: {
        value: 'READY',
      },
    });

    function clear() {
      form.name = '';
      form.code = '';
      form.itemGroup = undefined;
      form.stockLocation = undefined;
      form.type = '';
      form.brand = '';
      form.unit = '';
      form.supplier = null;
      form.warnAmount = 0;
      form.defaultPurchaseUnit = '';
    }

    const materialInput = computed(() => ({
      name: form.name,
      code: form.code,
      itemGroupId: (form.itemGroup as any)?.id,
      brand: form.brand,
      unit: form.unit,
      warnAmount: parseInt(form.warnAmount as any, 10),
      defaultPurchaseUnit: form.defaultPurchaseUnit,
      suppliers: form.suppliers.map((elm: any) => elm.id),
    }));

    onMounted(async () => {
      if (props.edit) {
        const result = (await getMaterial(route.value.params.id)).data;
        form.id = result.id;
        form.name = result.name;
        form.code = result.code;
        form.itemGroup = result.item_group;
        form.type = result.type;
        form.brand = result.brand;
        form.unit = result.unit;
        form.supplier = { id: result.supplier_id } as any;
        form.warnAmount = result.warn_amount;
        form.defaultPurchaseUnit = result.defaultPurchaseUnit;
        form.suppliers = result.suppliers;
      }
    });

    return {
      getSuppliers,
      confirmModal,

      getSuppliersResult,
      getItemGroups,
      getItemGroupsResult,
      getStockLocations,
      getStockLocationsResult,
      form,
      clear,

      hasPermission,
    };
  },
});

export default CommonFormWithMaterialEditor;
